import { memo, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import Input from "components/Commons/Input"
import RadioButton from "components/Commons/RadioButton"
import { ButtonStyled } from "theme/common/Button.styled"
import { IconSearch } from "theme/common/Icon.styled"
import { OptionFilterWrapper, SearchFormStyled } from "components/SearchForm/SearchForm.styled"
import { OptionsFilterEnum } from "enums/OptionsFilterEnum"
import { ISearch, ISearchForm } from "interfaces/ISearchForm"

const OrderSearchForm = memo(({ onClickSearch, search, optionFilter, isLoading }: ISearch) => {
  const [filter, setFilterValue] = useState(OptionsFilterEnum.query.toString())

  const { register, handleSubmit, setValue } = useForm<ISearchForm>()
  const { ref: refInputSearch } = register('search')

  const searchOptions = [
    { value: OptionsFilterEnum.query, label: "Id orden o SG" },
    { value: OptionsFilterEnum["custom.customer.id"], label: "RUT" },
  ]

  useEffect(() => {
    if (search) setValue("search", search)
    if (optionFilter) setFilterValue(optionFilter)
  }, [search, setValue, optionFilter])

  const handleClickSubmit = ({ search }: ISearchForm) => {
    onClickSearch({ query: search, optionFilter: filter })
  }

  const handleChangeOptionFilter = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setFilterValue(ev.target.value)
  }

  const resultPlaceHolder = searchOptions.find(({ value }: any) => value === filter)?.label

  return (
    <div style={{ marginBottom: '20px' }}>
      <OptionFilterWrapper>
        {searchOptions.map(({ value, label }) => (
          <RadioButton
            key={value}
            name="optionFilter"
            value={value}
            checked={value === filter}
            onChange={handleChangeOptionFilter}
          >
            {label}
          </RadioButton>
        ))}
      </OptionFilterWrapper>

      <SearchFormStyled onSubmit={handleSubmit(handleClickSubmit)}>
        <ButtonStyled variant="primary" disabled={isLoading}>
          <span>BUSCAR</span>
          <IconSearch />
        </ButtonStyled>
        <Input
          type="search"
          placeHolder={resultPlaceHolder}
          {...register("search")}
          ref={refInputSearch}
        />
      </SearchFormStyled>
    </div>
  )
})

export default OrderSearchForm
